import { render, staticRenderFns } from "./GroupForm.vue?vue&type=template&id=7a656c6d&scoped=true&"
import script from "./GroupForm.vue?vue&type=script&lang=ts&"
export * from "./GroupForm.vue?vue&type=script&lang=ts&"
import style0 from "./GroupForm.vue?vue&type=style&index=0&id=7a656c6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a656c6d",
  null
  
)

export default component.exports